module.exports = __webpack_public_path__ + "img/refresh.4ea71948.png";